import React, { type ReactNode } from 'react'

function CircleCheckIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83563 0.644531C3.99918 0.644531 0.890625 3.75308 0.890625 7.58953C0.890625 11.426 3.99918 14.5345 7.83563 14.5345C11.6721 14.5345 14.7806 11.426 14.7806 7.58953C14.7806 3.75308 11.6721 0.644531 7.83563 0.644531ZM9.59525 10.1038L7.83562 8.34413L6.076 10.1038C5.86899 10.3108 5.52841 10.3108 5.3214 10.1038C5.2179 10.0002 5.16447 9.86335 5.16447 9.72645C5.16447 9.58955 5.2179 9.45266 5.3214 9.34915L7.08103 7.58953L5.3214 5.82991C5.2179 5.7264 5.16447 5.5895 5.16447 5.45261C5.16447 5.31571 5.2179 5.17882 5.3214 5.07531C5.52841 4.86829 5.869 4.86829 6.076 5.07531L7.83562 6.83493L9.59525 5.07531C9.80225 4.86829 10.1428 4.86829 10.3498 5.07531C10.5569 5.28233 10.5569 5.6229 10.3498 5.82991L8.59023 7.58953L10.3498 9.34915C10.5569 9.55617 10.5569 9.89674 10.3498 10.1038C10.1428 10.3141 9.80227 10.3141 9.59525 10.1038Z"
        fill="var(--color-icon-danger)"
      />
    </svg>
  )
}

export default CircleCheckIcon
